import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRafflePageContext } from "./RafflePageContext";
import cls from "./styles.module.scss";
import {
  formatRaffleFinishedAt,
  formatRaffleScheduledDrawTime,
  getRaffleOrderAccountingTimeLeft,
} from "./utils";

const TIMER_TICK_MS = 1000;

export const RaffleTimeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8.64286 5C8.64286 4.64496 8.35504 4.35714 8 4.35714C7.64496 4.35714 7.35714 4.64496 7.35714 5V8C7.35714 8.20234 7.45241 8.39288 7.61429 8.51429L9.32857 9.8C9.6126 10.013 10.0155 9.95546 10.2286 9.67143C10.4416 9.3874 10.384 8.98445 10.1 8.77143L8.64286 7.67857V5Z"
      fill="#FCBD00"
    />
  </svg>
);

export const RaffleTimer = () => {
  const { t } = useTranslation();
  const { raffle, resultsSeconds } = useRafflePageContext();
  const [now, setNow] = useState(() => Date.now());
  const isFinishedStatus = Boolean(raffle.drawn_at && resultsSeconds === 0);

  useEffect(() => {
    if (isFinishedStatus) return undefined;

    const timerId = window.setInterval(() => {
      setNow(Date.now());
    }, TIMER_TICK_MS);

    return () => window.clearInterval(timerId);
  }, [isFinishedStatus]);

  const periodEndTime = new Date(raffle.period_end).getTime();
  const isAccountingActive =
    !Number.isNaN(periodEndTime) && now < periodEndTime;
  const timerText = (() => {
    if (isFinishedStatus) {
      return t("raffle.timer.finishedAt", {
        date: formatRaffleFinishedAt(raffle.scheduled_draw_at),
      });
    }

    if (!isAccountingActive) {
      return t("raffle.timer.drawScheduledAt", {
        time: formatRaffleScheduledDrawTime(raffle.scheduled_draw_at),
      });
    }

    const timeLeft = getRaffleOrderAccountingTimeLeft(raffle.period_end, now);

    if (timeLeft.unit === "days") {
      return t("raffle.timer.orderAccountingEndsInDays", {
        count: timeLeft.count,
      });
    }

    if (timeLeft.unit === "hours") {
      return t("raffle.timer.orderAccountingEndsInHours", {
        count: timeLeft.count,
      });
    }

    return t("raffle.timer.orderAccountingEndsInMinutes", {
      count: timeLeft.count,
    });
  })();

  return (
    <div className={cls.raffleTimer}>
      <RaffleTimeIcon />
      {timerText}
    </div>
  );
};
